var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHospital(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x36_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DDC27C"
    },
    d: "M390.149,104.534v361.1c0,25.515-20.851,46.366-46.366,46.366H46.366 c-1.414,0-2.757-0.071-4.17-0.212c-1.202-0.071-2.474-0.354-3.605-0.566c-1.202-0.212-2.403-0.424-3.534-0.777 c-0.565-0.142-1.131-0.283-1.626-0.424c-0.636-0.142-1.272-0.283-1.837-0.495c-2.262-0.707-4.453-1.696-6.573-2.827 c-0.848-0.353-1.555-0.848-2.332-1.343c-0.99-0.495-1.979-1.131-2.898-1.767c-0.919-0.636-1.696-1.272-2.544-1.979 c-0.142-0.071-0.212-0.212-0.353-0.283c-1.131-0.99-2.191-1.908-3.251-2.968c-1.06-1.06-1.979-2.05-2.968-3.251 c-0.071-0.141-0.212-0.212-0.283-0.353c-0.707-0.848-1.343-1.625-1.979-2.544c-0.636-0.919-1.272-1.909-1.767-2.898 c-0.495-0.777-0.99-1.484-1.343-2.332c-1.131-2.12-2.12-4.312-2.827-6.573c-0.212-0.565-0.353-1.202-0.494-1.838 c-0.141-0.495-0.283-1.06-0.424-1.626c-0.354-1.131-0.566-2.332-0.778-3.534c-0.212-1.131-0.495-2.332-0.565-3.604 C0.071,468.391,0,467.048,0,465.634v-361.1C0,79.09,20.85,58.24,46.366,58.24h297.418c1.696,0,3.463,0.071,5.159,0.353 c11.45,1.273,21.557,6.715,28.908,14.701c5.583,6.008,9.541,13.57,11.308,21.981c0.071,0.495,0.212,0.99,0.283,1.484 c0.142,0.848,0.283,1.767,0.424,2.686c0.071,0.353,0.071,0.707,0.071,1.131C390.078,101.849,390.149,103.192,390.149,104.534z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.185,
    y: 89.614,
    style: {
      fill: "#FFFFFF"
    },
    width: 327.779,
    height: 390.987
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.185,
    y: 89.615,
    style: {
      fill: "#F0EFEF"
    },
    width: 327.779,
    height: 14.448
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F8F1DF"
    },
    cx: 195.074,
    cy: 192.779,
    r: 76.076
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BCBCBC"
    },
    points: "297.347,50.112 296.004,58.24 293.319,73.789 289.29,97.537 100.859,97.537  100.718,96.477 100.364,94.357 99.516,89.621 96.831,73.789 94.145,58.24 92.802,50.112  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BCBCBC"
    },
    d: "M246.812,50.112c-0.848-27.141-22.547-49.051-49.687-50.041C196.417,0,195.781,0,195.074,0 h-0.353c-27.918,0.212-50.535,22.405-51.383,50.112c-0.071,0.424-0.071,0.919-0.071,1.343v0.353c0,0.707,0,1.414,0.071,2.049 c0,1.555,0.141,2.968,0.353,4.382c0.636,5.513,2.191,10.743,4.453,15.549c2.827,6.007,6.714,11.379,11.521,15.832 c3.322,3.11,6.997,5.725,11.026,7.916h48.768c4.029-2.191,7.704-4.806,11.026-7.916c4.806-4.453,8.694-9.825,11.521-15.832 c2.262-4.806,3.817-10.036,4.453-15.549c0.283-2.12,0.424-4.241,0.424-6.432C246.882,51.242,246.882,50.677,246.812,50.112z  M211.826,73.789c-4.594,3.605-10.461,5.725-16.751,5.725c-6.29,0-12.157-2.12-16.751-5.725 c-5.018-3.746-8.693-9.259-10.248-15.549c-0.495-2.05-0.707-4.241-0.707-6.432c0-0.566,0-1.201,0.071-1.696 c0.919-14.489,12.934-26.01,27.635-26.01c14.701,0,26.717,11.52,27.636,26.01c0.071,0.495,0.071,1.131,0.071,1.696 c0,2.191-0.212,4.382-0.707,6.432C220.519,64.53,216.844,70.043,211.826,73.789z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.23,
      fill: "#FFFFFF"
    },
    d: "M92.802,50.112l1.343,8.128h0.071l2.615,15.549h196.488l2.615-15.549h0.071 l1.343-8.128H92.802z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 141.127,
    y: 180.193,
    style: {
      fill: "#CE4442"
    },
    width: 107.895,
    height: 34.652
  }), /*#__PURE__*/React.createElement("rect", {
    x: 177.748,
    y: 143.572,
    style: {
      fill: "#CE4442"
    },
    width: 34.652,
    height: 107.895
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 44.278,
    y: 289.849,
    style: {
      fill: "#D2CBCD"
    },
    width: 301.593,
    height: 9.03
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.983,
    y: 324.162,
    style: {
      fill: "#D2CBCD"
    },
    width: 268.183,
    height: 19.865
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.983,
    y: 372.019,
    style: {
      fill: "#D2CBCD"
    },
    width: 268.183,
    height: 19.865
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.545,
    y: 419.877,
    style: {
      fill: "#D2CBCD"
    },
    width: 139.058,
    height: 19.865
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.04,
      fill: "#040000"
    },
    d: "M390.149,104.534v361.1c0,25.515-20.851,46.366-46.366,46.366H46.366 c-1.414,0-2.757-0.071-4.17-0.212c-1.202-0.071-2.474-0.354-3.605-0.566c-1.202-0.212-2.403-0.424-3.534-0.777 c-0.565-0.142-1.131-0.283-1.626-0.424c-0.636-0.142-1.272-0.283-1.837-0.495c-2.262-0.707-4.453-1.696-6.573-2.827 c-0.848-0.353-1.555-0.848-2.332-1.343c-0.99-0.495-1.979-1.131-2.898-1.767c-0.919-0.636-1.696-1.272-2.544-1.979 c-0.142-0.071-0.212-0.212-0.353-0.283c-1.131-0.99-2.191-1.908-3.251-2.968c-1.06-1.06-1.979-2.05-2.968-3.251 c-0.071-0.141-0.212-0.212-0.283-0.353c-0.707-0.848-1.343-1.625-1.979-2.544c-0.636-0.919-1.272-1.909-1.767-2.898 c-0.495-0.777-0.99-1.484-1.343-2.332c-1.131-2.12-2.12-4.312-2.827-6.573c-0.212-0.565-0.353-1.202-0.494-1.838 c-0.141-0.495-0.283-1.06-0.424-1.626c-0.354-1.131-0.566-2.332-0.778-3.534c-0.212-1.131-0.495-2.332-0.565-3.604 C0.071,468.391,0,467.048,0,465.634v-14.631l161.148-161.148l21.911-21.91l0.07-0.071l16.468-16.398l49.405-49.405l21.134-21.204 l0.07-0.071l76.899-76.757l11.804-11.875l0.07-0.07l8.482-8.552l3.251-3.251l7.139-6.997c5.583,6.008,9.541,13.57,11.308,21.981 c0.071,0.495,0.212,0.99,0.283,1.484c0.142,0.848,0.283,1.767,0.424,2.686c0.071,0.353,0.071,0.707,0.071,1.131 C390.078,101.849,390.149,103.192,390.149,104.534z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHospital);
export default __webpack_public_path__ + "static/media/hospital.8c3fafcb5d28a1a3a1f65f6f1480b642.svg";
export { ForwardRef as ReactComponent };